import { createSlice } from "@reduxjs/toolkit";
export const HOME_SLICE = "home"

const homeSlice = createSlice({
    name: HOME_SLICE,
    initialState: {
        isLoading: false,
        remiainingLeaveList: [],
        leaveRequestCount: [],
        leaveRequestPagingWithoutPending: [],
        allRemainingLeaveLists: []
        // currentMasterData: {},
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setRemiainingLeaveList(state, action) {
            state.remiainingLeaveList = action.payload;
        },
        setMyLeaveRequestCount(state, action) {
            state.leaveRequestCount = action.payload;
        },
        setLeaveRequestPagingWithoutPending(state, action) {
            state.leaveRequestPagingWithoutPending = action.payload;
        },
        setAllRemainingLeaveLists(state, action) {
            state.allRemainingLeaveLists = action.payload;
        },
        setTeamWorkingCount(state, action) {
            state.teamWorkingCount = action.payload;
        },
        setTeamWorkingDetail(state, action) {
            state.teamWorkingDetail = action.payload;
        },
    },
});

export const { setIsLoading, setRemiainingLeaveList, setMyLeaveRequestCount, setLeaveRequestPagingWithoutPending, setAllRemainingLeaveLists, setTeamWorkingCount, setTeamWorkingDetail, } = homeSlice.actions;
export default homeSlice.reducer;
